import React, {Component} from "react"

import Title from "../../../components/global/Title/Title"

class PeopleCard extends Component {
  render() {
    return(
      <div className="relative rounded-lg overflow-hidden w-full">
        <div className="relative z-10 w-full h-68 rounded-lg overflow-hidden">
          <img style={{ transition: 'opacity 300ms ease 0s' }} className="absolute inset-0 w-full	h-full object-cover object-center opacity-100" src={this.props.imageSrc} alt="alt"/>
        </div>
        <div className="relative my-4">
          <Title className="" level="3">{this.props.title}</Title>
          {/* <div className="opacity-25 font-bold h-6"><span>{this.props.function}</span></div> */}
          <div className="opacity-25 font-bold h-6"><span>{this.props.position}</span></div>
        </div>
      </div>
    );
  }
}

export default PeopleCard
